import { useMediaQuery, useTheme } from '@mui/material'

type ResponsiveChartHeights = {
  /** Height for the overview/bid curve chart section */
  overviewChartHeight: number
}

/**
 * Hook that returns responsive chart heights based on screen size.
 * Uses MUI breakpoints to determine appropriate heights for different devices.
 */
function useResponsiveChartHeight(): ResponsiveChartHeights {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'))

  const getOverviewChartHeight = () => {
    if (isSmallScreen) return 140
    if (isMediumScreen) return 170
    return 200
  }

  return {
    overviewChartHeight: getOverviewChartHeight(),
  }
}

export { useResponsiveChartHeight }
